// ─── Saved Options Sticky Strip ─────────────────────────────────
// Sits directly under the EmployerPortal header on every page. Persists until
// the employer selects an option or the AM removes the recommendation.
import React from 'react';
import { C } from '../../utils/styles';
import Icon from '../Icon';

export default function SavedOptionsStickyStrip({ client, onCompare }) {
  const savedOptions = client?.savedOptions || null;
  if (!savedOptions || !savedOptions.options || savedOptions.options.length === 0) return null;

  const options = savedOptions.options;
  const selectedId = savedOptions.selectedOptionId;
  const selectedOption = selectedId ? options.find((o) => o.id === selectedId) : null;

  // Eligibility comparison hook (Option A vs Option B)
  const a = options[0];
  const b = options[1];
  const aRate = a?.section125?.eligibilityRate;
  const bRate = b?.section105 ? b.section105.newEligibilityRate : b?.section125?.eligibilityRate;

  return (
    <div
      data-testid="saved-options-sticky-strip"
      style={{
        background: '#eff6ff',
        borderBottom: `2px solid #85B7EB`,
        color: '#0C447C',
        padding: '8px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        flexWrap: 'wrap',
        fontSize: 13,
        fontWeight: 600,
      }}
    >
      <Icon name="bookmark" style={{ fontSize: 16, color: '#0C447C' }} />
      {selectedOption ? (
        <>
          <span style={{ flex: 1, minWidth: 200 }}>
            <strong>You selected {selectedOption.label}</strong> · Your account manager has been notified.
          </span>
          <button
            type="button"
            onClick={onCompare}
            data-testid="strip-compare-btn"
            style={stripBtnStyle}
          >
            Review options
          </button>
        </>
      ) : (
        <>
          <span>
            <strong>{options.length} saved options to review</strong>
          </span>
          {aRate != null && bRate != null && (
            <span
              style={{
                padding: '3px 10px',
                background: '#fff',
                border: `1px solid #85B7EB`,
                borderRadius: 999,
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 12,
                fontWeight: 800,
                color: '#0C447C',
              }}
            >
              {aRate}% vs {bRate}%
              {bRate > aRate && <span style={{ color: C.green, marginLeft: 6 }}>+{bRate - aRate}%</span>}
            </span>
          )}
          <span style={{ flex: 1 }} />
          <button
            type="button"
            onClick={onCompare}
            data-testid="strip-compare-btn"
            style={stripBtnStyle}
          >
            Compare options
            <Icon name="arrow-forward" style={{ fontSize: 12, marginLeft: 6, verticalAlign: 'middle' }} />
          </button>
        </>
      )}
    </div>
  );
}

const stripBtnStyle = {
  padding: '6px 14px',
  background: '#0C447C',
  color: '#fff',
  border: 'none',
  borderRadius: 6,
  fontSize: 12,
  fontWeight: 800,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
};
